var map = {
	"./CanvasClear": 51,
	"./CanvasClear.js": 51,
	"./CanvasMove": 52,
	"./CanvasMove.js": 52,
	"./CommandAbstract": 31,
	"./CommandAbstract.js": 31,
	"./ComponentDelete": 53,
	"./ComponentDelete.js": 53,
	"./ComponentDrag": 54,
	"./ComponentDrag.js": 54,
	"./ComponentEnter": 55,
	"./ComponentEnter.js": 55,
	"./ComponentExit": 56,
	"./ComponentExit.js": 56,
	"./ComponentNext": 57,
	"./ComponentNext.js": 57,
	"./ComponentPrev": 58,
	"./ComponentPrev.js": 58,
	"./ComponentStyleClear": 59,
	"./ComponentStyleClear.js": 59,
	"./CopyComponent": 60,
	"./CopyComponent.js": 60,
	"./DeleteComponent": 61,
	"./DeleteComponent.js": 61,
	"./ExportTemplate": 62,
	"./ExportTemplate.js": 62,
	"./Fullscreen": 63,
	"./Fullscreen.js": 63,
	"./MoveComponent": 64,
	"./MoveComponent.js": 64,
	"./OpenAssets": 65,
	"./OpenAssets.js": 65,
	"./OpenBlocks": 66,
	"./OpenBlocks.js": 66,
	"./OpenLayers": 67,
	"./OpenLayers.js": 67,
	"./OpenStyleManager": 68,
	"./OpenStyleManager.js": 68,
	"./OpenTraitManager": 69,
	"./OpenTraitManager.js": 69,
	"./PasteComponent": 70,
	"./PasteComponent.js": 70,
	"./Preview": 71,
	"./Preview.js": 71,
	"./Resize": 72,
	"./Resize.js": 72,
	"./SelectComponent": 23,
	"./SelectComponent.js": 23,
	"./SelectPosition": 35,
	"./SelectPosition.js": 35,
	"./ShowOffset": 73,
	"./ShowOffset.js": 73,
	"./SwitchVisibility": 74,
	"./SwitchVisibility.js": 74
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;